export const SAFETY_ZONE_SENSITIVITY_LEVELS = Object.freeze([
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' }
])

// Given a division/hospital object with safety_zone_sensitivity_high/medium/low
// fields, returns the levels that have a configured (non-blank) value.
export function configuredSensitivityLevels(source) {
  if (!source) {
    return []
  }
  return SAFETY_ZONE_SENSITIVITY_LEVELS.filter(level => {
    const value = source[`safety_zone_sensitivity_${level.value}`]
    return value !== null && value !== undefined && value !== ''
  })
}
